import $ from 'jquery';

Drupal.behaviors.gutfeelingExpandable = {
  attach: function (context) {
    const $button = $('.expandable-button', context);
    if ($button.attr('aria-controls')) {
      once('gutfeelingExpandable', '.expandable-button', context).forEach((button) => {
        $(button).on('click', function () {
          const regionId = $(this).attr('aria-controls');

          if (regionId) {
            let $region = $('#' + regionId),
              isExpanded = $(this).attr('aria-expanded');

            if (isExpanded == 'false') {
              $(this).attr('aria-expanded', 'true');
            }
            else {
              $(this).attr('aria-expanded', 'false');
            }
          }
        });
      });
    }
  }
};
